import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import useColors from "../../../../api/hooks/useColors";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function ZscalerZiaConnectForm({ onSubmit, guideMode }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showAPI, setShowAPI] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowAPI = () => setShowAPI(!showAPI);
  const handleMouseDownAPI = () => setShowAPI(!showAPI);
  const colors = useColors();

  const formInitialValues = {
    username: "",
    password: "",
    api_key: "",
    baseUrl: "",
  };
  const formCheckoutSchema = yup.object().shape({
    username: yup.string().required("required"),
    password: yup.string().required("required"),
    api_key: yup.string().required("required"),
    baseUrl: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="username"
                label="Username"
                value={values.username}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.username && !!errors.username}
                helperText={touched.username && errors.username}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                type={showPassword ? "text" : "password"}
                name="password"
                autoComplete="off"
                label="Password"
                value={values.password}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.password && !!errors.password}
                helperText={touched.password && errors.password}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                type={showAPI ? "text" : "password"}
                name="api_key"
                label="API Key"
                value={values.api_key}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.api_key && !!errors.api_key}
                helperText={touched.api_key && errors.api_key}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle api key visibility"
                        onClick={handleClickShowAPI}
                        onMouseDown={handleMouseDownAPI}
                      >
                        {showAPI ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="baseUrl"
                label="Base URL"
                value={values.baseUrl}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.baseUrl && !!errors.baseUrl}
                helperText={touched.baseUrl && errors.baseUrl}
                disabled={guideMode}
              />
            </Box>
            <Typography variant="body2">
              * Without the{" "}
              <code
                style={{ padding: "4px", backgroundColor: colors.grey_300 }}
              >
                /api/v1
              </code>
            </Typography>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
